import { axios_nomination } from '@/plugins/axios';
import configuration from '@/configurations';

class QueryRepository {
  /**
   * @param {Number} user_id
   * @param {Object} criteria
   * @returns {Promise}
   */
  async searchUserQueryList(user_id, criteria = {}) {
    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v1/users/${user_id}/queries`,
        {
          params: criteria,
        }
      );

    return result.data;
  }

  /**
   * @param {Number} user_id
   * @param {Object} criteria
   * @returns {Promise}
   */
  async searchV2UserQueryList(criteria = {}) {
    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v2/user/queries`,
        {
          params: criteria,
        }
      );

    return result.data;
  }

  /**
   * @param {Number} user_id
   * @param {Object} criteria
   * @returns {Promise}
   */
  async searchUserQueryListLight(user_id, criteria = {}) {
    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v1/users/${user_id}/queries-light`,
        {
          params: criteria,
        }
      );

    return result.data;
  }

  /**
   * @param {Number} user_id
   * @param {Object} criteria
   * @returns {Promise}
   */
  async readQuery(user_id, query_id) {
    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v1/users/${user_id}/queries/${query_id}`
      );

    return result.data;
  }

  /**
   * @param {Number} user_id
   * @param {Object} criteria
   * @returns {Promise}
   */
  async readQueryByIdList(user_id, query_id) {
    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v1/users/${user_id}/queries`,
        {
          params: {
            id_list: [query_id],
          },
        }
      );

    return result.data;
  }

  /**
   * @param {number} user_id
   * @param {Object} data
   *
   * @returns {Promise}
   */
  async createQueryV1(user_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/users/${user_id}/queries`,
      data
    );

    return response.data;
  }

  /**
   * @param {Object} data
   *
   * @returns {Promise}
   */
  async createQuery(data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v2/user/queries`,
      data
    );

    return response.data;
  }

  /**
   * @param {Number} query_id
   * @param {Object} data
   *
   * @returns {Promise}
   */
  async updateQuery(query_id, data) {
    const response = await axios_nomination.patch(
      `${configuration.api_host}/v2/user/queries/${query_id}`,
      data
    );

    return response.data;
  }

  /**
   * @param {Number} query_id
   *
   * @returns {Promise}
   */
  async deleteQuery(query_id) {
    const response = await axios_nomination
      .delete(`${configuration.api_host}/v2/user/queries/${query_id}`);

    return response.data;
  }

  /**
   * @param {Number} user_id
   * @param {Number} query_id
   * @param {Object} data
   *
   * @returns {Promise}
   */
  async duplicateQuery(user_id, query_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/users/${user_id}/queries/${query_id}/duplicate`,
      data
    );

    return response.data;
  }

  /**
   * @param {Number} user_id
   * @param {Number} query_id
   * @param {Object} data
   *
   * @returns {Promise}
   */
  async mergeQueries(user_id, query_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/users/${user_id}/queries/${query_id}/merge`,
      data
    );

    return response.data;
  }

  /**
   * @param {Number} user_id
   * @param {Number} query_id
   * @param {Object} data
   *
   * @returns {Promise}
   */
  async splitQuery(user_id, query_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/users/${user_id}/queries/${query_id}/split`,
      data
    );

    return response.data;
  }

  /**

   * @param {Object} input
   * @returns {Promise}
   */
  async getQueriesV2(input) {
    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v2/user/queries`,
        {
          params: input,
        }
      );

    return result.data;
  }

  /**
   * @param {Object} input
   * @returns {Promise}
   */
  async getQueriesV1(user_id, params) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/users/${user_id}/queries`,
      { params });

    return result.data;
  }

  /**
   * @param {Object} input
   * @returns {Promise}
   */
  async getQueriesCount(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/users/queries/count`,
      { params: input });

    return result.data;
  }

  /**
   * @param {Number} user_id
   * @returns {Promise}
   */
  async getUserQueryCounters(user_id) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/users/${user_id}/queries/count`
    );

    return result.data;
  }

  /**
   * @param {Object} input
   * @returns {Promise}
   */
  async addQuerySharing(input) {
    const {
      query_id,
      user_id,
      shared_user_id,
    } = input;

    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/users/${user_id}/queries/${query_id}/sharings`,
      {
        shared_user_id,
      }
    );

    return response.data;
  }

  /**
   * @param {Number} user_id
   * @param {Object} params
   * @returns {Promise}
   */
  async searchBookmarks(user_id, params) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/users/${user_id}/bookmarks`,
      {
        params,
      }
    );

    return result.data;
  }

  /**
   * @param {Number} user_id
   * @param {Object} data
   * @returns {Promise}
   */
  async createBookmark(user_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/users/${user_id}/bookmarks`,
      data
    );

    return response.data;
  }

  /**
   * @param {Number} user_id
   * @param {Number} bookmark_id
   * @returns {Promise}
   */
  async deleteBookmark(user_id, bookmark_id) {
    const response = await axios_nomination.delete(
      `${configuration.api_host}/v1/users/${user_id}/bookmarks/${bookmark_id}`
    );

    return response.data;
  }

  /**
   * @param {Object} input
   * @returns {Promise}
   */
  async removeQuerySharing(input) {
    const {
      query_id,
      sharing_id,
      user_id,
    } = input;

    const response = await axios_nomination.delete(
      `${configuration.api_host}/v1/users/${user_id}/queries/`
        + `${query_id}/sharings/${sharing_id}`
    );

    return response.data;
  }
}

const query_repository = new QueryRepository();

export {
  query_repository,
};
